import { render, staticRenderFns } from "./CouponCatalog.vue?vue&type=template&id=ef88befe&"
import script from "./CouponCatalog.vue?vue&type=script&lang=js&"
export * from "./CouponCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CouponCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports